import { Pipe, PipeTransform } from '@angular/core';
import { NavTree, Omnibox } from '@local/client-contracts';
import { Results } from '@local/client-contracts';

@Pipe({
  name: 'barItemToSuggestionTag',
  pure: true,
})
export class BrowseBarItemToSuggestionTagPipe implements PipeTransform {
  transform(item: Results.BrowseBarItem | any, type: 'app' | 'type' | 'view'): Omnibox.Tag & { disabled: boolean } {
    if (type === 'view') {
      const { icon, title, id, type } = item as NavTree.Node;
      return { icon, title, id, type, disabled: false, label: '' };
    } else {
      const { appId, type, syncStatus, stale, name, links, icon } = item;
      return { icon, id: appId + ':' + type, type, title: name, disabled: item.syncStatus === 'Preparing', label: '' };
    }
  }
}
